module.exports = __webpack_public_path__ + "img/p3-xyz.83ec652d.svg";